'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var sha = require('multihashing-async/src/sha');

var protobuf = require('protons');

var multibase = require('multibase');

var errcode = require('err-code');

var crypto = require('./rsa');

var pbm = protobuf(require('./keys.proto'));

require('node-forge/lib/sha512');

require('node-forge/lib/ed25519');

var forge = require('node-forge/lib/forge');

var RsaPublicKey = /*#__PURE__*/function () {
  function RsaPublicKey(key) {
    _classCallCheck(this, RsaPublicKey);

    this._key = key;
  }

  _createClass(RsaPublicKey, [{
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, sig) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", crypto.hashAndVerify(this._key, sig, data));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function verify(_x, _x2) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "marshal",
    value: function marshal() {
      return crypto.utils.jwkToPkix(this._key);
    }
  }, {
    key: "encrypt",
    value: function encrypt(bytes) {
      return crypto.encrypt(this._key, bytes);
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function () {
      var _hash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", sha.multihashing(this.bytes, 'sha2-256'));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function hash() {
        return _hash.apply(this, arguments);
      }

      return hash;
    }()
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PublicKey.encode({
        Type: pbm.KeyType.RSA,
        Data: this.marshal()
      });
    }
  }]);

  return RsaPublicKey;
}();

var RsaPrivateKey = /*#__PURE__*/function () {
  // key       - Object of the jwk format
  // publicKey - Buffer of the spki format
  function RsaPrivateKey(key, publicKey) {
    _classCallCheck(this, RsaPrivateKey);

    this._key = key;
    this._publicKey = publicKey;
  }

  _createClass(RsaPrivateKey, [{
    key: "genSecret",
    value: function genSecret() {
      return crypto.getRandomValues(16);
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(message) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", crypto.hashAndSign(this._key, message));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sign(_x3) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "decrypt",
    value: function decrypt(bytes) {
      return crypto.decrypt(this._key, bytes);
    }
  }, {
    key: "marshal",
    value: function marshal() {
      return crypto.utils.jwkToPkcs1(this._key);
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function () {
      var _hash2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", sha.multihashing(this.bytes, 'sha2-256'));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function hash() {
        return _hash2.apply(this, arguments);
      }

      return hash;
    }()
    /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @returns {Promise<String>}
     */

  }, {
    key: "id",
    value: function () {
      var _id = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var hash;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.public.hash();

              case 2:
                hash = _context5.sent;
                return _context5.abrupt("return", multibase.encode('base58btc', hash).toString().slice(1));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function id() {
        return _id.apply(this, arguments);
      }

      return id;
    }()
    /**
     * Exports the key into a password protected PEM format
     *
     * @param {string} password - The password to read the encrypted PEM
     * @param {string} [format] - Defaults to 'pkcs-8'.
     */

  }, {
    key: "export",
    value: function () {
      var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(password) {
        var format,
            pem,
            buffer,
            asn1,
            privateKey,
            options,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                format = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 'pkcs-8';
                // eslint-disable-line require-await
                pem = null;
                buffer = new forge.util.ByteBuffer(this.marshal());
                asn1 = forge.asn1.fromDer(buffer);
                privateKey = forge.pki.privateKeyFromAsn1(asn1);

                if (!(format === 'pkcs-8')) {
                  _context6.next = 10;
                  break;
                }

                options = {
                  algorithm: 'aes256',
                  count: 10000,
                  saltSize: 128 / 8,
                  prfAlgorithm: 'sha512'
                };
                pem = forge.pki.encryptRsaPrivateKey(privateKey, password, options);
                _context6.next = 11;
                break;

              case 10:
                throw errcode(new Error("Unknown export format '".concat(format, "'. Must be pkcs-8")), 'ERR_INVALID_EXPORT_FORMAT');

              case 11:
                return _context6.abrupt("return", pem);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _export(_x4) {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "public",
    get: function get() {
      if (!this._publicKey) {
        throw errcode(new Error('public key not provided'), 'ERR_PUBKEY_NOT_PROVIDED');
      }

      return new RsaPublicKey(this._publicKey);
    }
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PrivateKey.encode({
        Type: pbm.KeyType.RSA,
        Data: this.marshal()
      });
    }
  }]);

  return RsaPrivateKey;
}();

function unmarshalRsaPrivateKey(_x5) {
  return _unmarshalRsaPrivateKey.apply(this, arguments);
}

function _unmarshalRsaPrivateKey() {
  _unmarshalRsaPrivateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(bytes) {
    var jwk, keys;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            jwk = crypto.utils.pkcs1ToJwk(bytes);
            _context7.next = 3;
            return crypto.unmarshalPrivateKey(jwk);

          case 3:
            keys = _context7.sent;
            return _context7.abrupt("return", new RsaPrivateKey(keys.privateKey, keys.publicKey));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _unmarshalRsaPrivateKey.apply(this, arguments);
}

function unmarshalRsaPublicKey(bytes) {
  var jwk = crypto.utils.pkixToJwk(bytes);
  return new RsaPublicKey(jwk);
}

function fromJwk(_x6) {
  return _fromJwk.apply(this, arguments);
}

function _fromJwk() {
  _fromJwk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(jwk) {
    var keys;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return crypto.unmarshalPrivateKey(jwk);

          case 2:
            keys = _context8.sent;
            return _context8.abrupt("return", new RsaPrivateKey(keys.privateKey, keys.publicKey));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fromJwk.apply(this, arguments);
}

function generateKeyPair(_x7) {
  return _generateKeyPair.apply(this, arguments);
}

function _generateKeyPair() {
  _generateKeyPair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(bits) {
    var keys;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return crypto.generateKey(bits);

          case 2:
            keys = _context9.sent;
            return _context9.abrupt("return", new RsaPrivateKey(keys.privateKey, keys.publicKey));

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _generateKeyPair.apply(this, arguments);
}

module.exports = {
  RsaPublicKey: RsaPublicKey,
  RsaPrivateKey: RsaPrivateKey,
  unmarshalRsaPublicKey: unmarshalRsaPublicKey,
  unmarshalRsaPrivateKey: unmarshalRsaPrivateKey,
  generateKeyPair: generateKeyPair,
  fromJwk: fromJwk
};